module.exports = __webpack_public_path__ + "img/cloud-hail.37c89843.svg";